export const sortAlphabetical = (arr?: string[] | null) =>
  [...(arr || [])].sort((a, b) => {
    // TODO: update hardcoded 'en' to Spanish when change to Spanish is implemented
    return a.localeCompare(b, 'en', { numeric: true });
  });
